import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import cross from '../../genericComponents/assets/cross.svg'
import { SIZE_MEDIUM } from '../../genericComponents/buttons/RectangleActionButton'
import SVGIcon from '../../svg/SVGIcon'
import { withEverySelectorTruthy } from '../../utils/react-redux'
import useEventCallback from '../../utils/useEventCallback'
import UserLoginButton from '../UserLoginButton'
import { withUserNotConnected } from '../shared/withKeycloak'
import s from './UserAccountIncentivePreferences.less'
import { hideUserAccountPreferencesIncentive } from '../../../store/incentive/incentiveSlice'
import { selectIsPreferencesUserAccountIncentiveDisplayed } from '../../../store/incentive/incentive.selectors'

const UserAccountIncentivePreferences = () => {
  const dispatch = useDispatch()
  const hideIncentive = () => dispatch(hideUserAccountPreferencesIncentive())
  const onClose = useEventCallback(hideIncentive)

  useEffect(() => hideIncentive, [])

  return (
    <div className={s.root}>
      <div className={s.closeButton} onClick={onClose}>
        <SVGIcon url={cross} />
      </div>
      <div className={s.text}>
        <span>{"Ça vous dirait qu'on garde en mémoire"}</span> <span className={s.highlight}>vos préférences ?</span>
      </div>
      <div>
        <UserLoginButton size={SIZE_MEDIUM} />
      </div>
    </div>
  )
}

export default withUserNotConnected(
  withEverySelectorTruthy(selectIsPreferencesUserAccountIncentiveDisplayed)(UserAccountIncentivePreferences)
)
